import React from 'react';
import AdminHeader from '../../components/adminHeader';
import AdminFooter from '../../components/adminFooter';

const PartnerLogin = () => {
  return (
    <div className="w-full h-full flex flex-col bg-[#00000071]">
      <AdminHeader />
      <div
        style={{
          backgroundImage: "url(/assets/img/landing/landing-bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="flex-grow flex flex-col items-center justify-center w-full relative pt-6 px-4"
      >
        <div className="gothic-panel w-full max-w-md p-8">
          <h1 className="gothic-heading text-center mb-6">Partner Login</h1>
          <form className="space-y-4">
            <div>
              <label htmlFor="email" className="block gothic-text-silver mb-1">Email</label>
              <input
                type="email"
                id="email"
                className="gothic-input w-full"
                placeholder="Enter your email"
              />
            </div>
            <div>
              <label htmlFor="password" className="block gothic-text-silver mb-1">Password</label>
              <input
                type="password"
                id="password"
                className="gothic-input w-full"
                placeholder="Enter your password"
              />
            </div>
            <button type="submit" className="gothic-button gothic-button-primary w-full">Login</button>
          </form>
          <p className="gothic-text-silver text-center mt-4">
            Don't have an account? <a href="/partnerregister" className="gothic-link">Register here</a>
          </p>
        </div>
      </div>
      <AdminFooter />
    </div>
  );
};

export default PartnerLogin;
